<div class="avatar" [ngClass]="[themeClass, sizeClass]" role="img" [attr.aria-label]="'Avatar of ' + userName">
  {{ initials }}
</div>
